import { jsx } from "@ecopages/jsx/jsx-runtime";
export function Intrinsic({
  as,
  children,
  ...props
}) {
  const Tag = as ?? "div";
  const DynamicTag = Tag;
  return /* @__PURE__ */jsx(DynamicTag, {
    ...props,
    children
  });
}